import Vue from 'vue';
import clickOutside from './clickOutside';

// Tüm direktifleri kaydet
Vue.directive('click-outside', clickOutside);

export default {
  clickOutside
}; 